export interface DatePickerFormat {
  muiPickerFormat: string
  placeholder: string
  example: string
}

export const dateFormatKeys = ['DMY', 'MDY', 'DMMMYYYY', 'MMMDYYYY'] as const

export type DateFormatKey = (typeof dateFormatKeys)[number]

type DatePickerFormatByStandard = {
  [formatKey in DateFormatKey]: DatePickerFormat
}

export const datePickerFormatByStandard: DatePickerFormatByStandard = {
  DMY: {
    muiPickerFormat: 'dd/MM/yyyy',
    placeholder: 'dd/mm/yyyy',
    example: '25/12/2020',
  },
  MDY: {
    muiPickerFormat: 'MM/dd/yyyy',
    placeholder: 'mm/dd/yyyy',
    example: '12/25/2020',
  },
  DMMMYYYY: {
    muiPickerFormat: 'dd MMM yyyy',
    placeholder: 'Select',
    example: '25 Dec 2020',
  },
  MMMDYYYY: {
    muiPickerFormat: 'MMM dd yyyy',
    placeholder: 'Select',
    example: 'Dec 25 2020',
  },
} as const
